import React, { useEffect, useState } from 'react';
import { ConvertDouble } from 'util/helpers/helperFunctions';
import { NumberTextBoxStyle } from './Textbox';
import './TextBox.css';

interface IProps {
  name: string;
  value: string;
  precision?: number;
  onChange?: (event: any) => void;
  onChangeWithValidation?: (event: any) => void;
  isReadonly?: boolean;
  style?: any;
  isDisabled?: boolean;
  id?: string;
  theme?: string;
}

interface IState {
  unFormattedValue: string | undefined;
  showFormatted: boolean;
  isValid: boolean;
}

const ToolTipData = '1m - 1,000.00 (thousands) \n1mm - 1,000,000.00 (millions) \n1b - 1,000,000,000.00 (billions)';

let DisabledBoxStyle = {};

const CurrencyTextbox: React.FC<IProps> = (props) => {
  const [unFormattedValue, setUnFormattedValue] = useState<string | undefined>(props.value);
  const [showFormatted, setShowFormatted] = useState(true);
  const [isValid, setIsValid] = useState(true);

  useEffect(() => {
    if (props.isDisabled) {
      DisabledBoxStyle = {
        color: '#ddddda',
      };
    }
  }, []);

  useEffect(() => {
    if (props.isDisabled) {
      DisabledBoxStyle = {
        color: '#ddddda',
      };
    }
    setUnFormattedValue(props.value);
  }, [props.value, props.isDisabled]);

  const onFocus = () => {
    setShowFormatted(false);
  };

  const onBlurHandler = async () => {
    let num = unFormattedValue;
    let newNum;
    if (num && !isNumber(num)) {
      const length = num.length;
      num = num.toLowerCase();
      if (num.endsWith('m') && isNumber(num.substr(0, length - 1))) {
        newNum = (Number(num.substr(0, length - 1)) * 1000).toString();
      } else if (num.endsWith('k') && isNumber(num.substr(0, length - 1))) {
        newNum = (Number(num.substr(0, length - 1)) * 1000).toString();
      } else if (num.endsWith('mm') && isNumber(num.substr(0, length - 2))) {
        newNum = (Number(num.substr(0, length - 2)) * 1000000).toString();
      } else if (num.endsWith('b') && isNumber(num.substr(0, length - 1))) {
        newNum = (Number(num.substr(0, length - 1)) * 1000000000).toString();
      } else {
        if (props.onChangeWithValidation === undefined) {
          newNum = '';
        } else {
          newNum = num;
        }
      }
    } else {
      newNum = unFormattedValue;
    }
    const finalValue =
      newNum != null && newNum !== ''
        ? isNumber(newNum)
          ? ConvertDouble(newNum)
              .toFixed(props.precision ? props.precision : 2)
              .toString()
          : newNum
        : '';
    setShowFormatted(true);
    setUnFormattedValue(finalValue);
    await Promise.resolve();
    const params = {
      value: finalValue,
      name: props.name,
    };
    if (props.onChange) {
      props.onChange(params);
    } else if (props.onChangeWithValidation) {
      props.onChangeWithValidation(params);
    }
  };

  const onChangeHandler = (event: any) => {
    setUnFormattedValue(event.target.value);
  };

  let val;
  showFormatted &&
  unFormattedValue != null &&
  unFormattedValue !== '' &&
  isNumber(unFormattedValue)
    ? (val = ConvertDouble(unFormattedValue).toLocaleString('en', {
        minimumFractionDigits: props.precision ? props.precision : 2,
      }))
    : (val = unFormattedValue);

  return (
    <div style={{ width: '100%', textAlign: 'right' }} className={'currency-textbox'}>
      {props.isReadonly ? (
        <span data-testid={props.name} style={{ paddingLeft: 6 }}>
          {val}
        </span>
      ) : (
        <input
          data-testid={props.name}
          title={ToolTipData}
          name={props.name}
          id={props.id}
          value={val}
          type="search"
          className={`currencyTextBox ${props.theme || ''}`}
          disabled={props.isDisabled}
          style={{
            ...NumberTextBoxStyle,
            ...props.style,
            ...DisabledBoxStyle,
          }}
          readOnly={props.isReadonly}
          onFocus={onFocus}
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
        />
      )}
    </div>
  );
};

const isNumber = (val: string) => {
  if (val) {
    val = val.toString().replace(new RegExp(',', 'g'), '');
  }
  return !isNaN(Number(val));
};

export default CurrencyTextbox;
